<!-- =========================================================================================
    File Name: Main.vue
    Description: Main layout
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="layout--main" :class="[navbarClasses, footerClasses, {'app-page': isAppPage}]">
    <student-navbar :navbarColor="siteNavbarColor" :class="[{'text-white': isNavbarDark && !isThemeDark}, {'text-base': !isNavbarDark && isThemeDark}]" />
    <div  style="margin-top: -10px; padding-left:20px;padding-right:20px">
      <div class="router-content" :class="{'mt-0': navbarType == 'hidden'}">
        <transition :name="routerTransition">
          <div class="router-header flex flex-wrap items-center mb-6" v-if="$route.meta.breadcrumb || $route.meta.pageTitle">
          </div>
        </transition>
        <div class="content-area__content">
          <back-to-top bottom="2%" visibleoffset="30" v-if="!hideScrollToTop">
            <vs-button icon-pack="feather" icon="icon-arrow-up" class="shadow-lg" />
          </back-to-top>
          <transition :name="routerTransition" mode="out-in">
            <router-view @changeRouteTitle="changeRouteTitle"></router-view>
          </transition>
        </div>
      </div>
    </div>
    <the-footer></the-footer>
  </div>
</template>

<script>
import VxSidebar from "@/layouts/components/vx-sidebar/VxSidebar.vue";
import StudentNavbar from "@/layouts/components/StudentNavbar.vue";
import TheFooter from "@/layouts/components/TheFooter.vue";
import themeConfig from "../../../themeConfig.js";
import BackToTop from "vue-backtotop";

export default {
  components: {
    VxSidebar,
    StudentNavbar,
    TheFooter,
    BackToTop
  },
  data() {
    return {
      navbarType: "", //themeConfig.navbarType || "static",
      navbarColor: "", //themeConfig.navbarColor || "#fff",
      footerType: themeConfig.footerType || "static",
      routerTransition: themeConfig.routerTransition || "none",
      isNavbarDark: false,
      routeTitle: this.$route.meta.pageTitle,
      windowWidth: window.innerWidth, //width of windows
      hideScrollToTop: themeConfig.hideScrollToTop
    };
  },
  watch: {
    $route() {
      this.routeTitle = this.$route.meta.pageTitle;
    },
    isThemeDark(val) {
      if (this.navbarColor == "#fff" && val) {
        this.updateNavbarColor("#10163a");
      } else {
        this.updateNavbarColor("#fff");
      }
    }
  },
  computed: {
    isAppPage() {
      if (this.$route.path.includes("/apps/")) return true;
      else return false;
    },
    isThemeDark() {
      return this.$store.state.theme == "dark";
    },
    siteNavbarColor() {
      var navbarColorValue = "";
      if (this.navbarColor) {
        navbarColorValue = this.navbarColor;
      }

      if (localStorage.getItem("userSiteInfo")) {
        if (JSON.parse(localStorage.getItem("userSiteInfo")) instanceof Array) {
          navbarColorValue = JSON.parse(localStorage.getItem("userSiteInfo"))[0]
            .navbarColor;
          if (this.navbarColor) {
            navbarColorValue = this.navbarColor;
          }
          return navbarColorValue;
        } else {
          navbarColorValue = JSON.parse(localStorage.getItem("userSiteInfo"))
            .navbarColor;
          if (this.navbarColor) {
            navbarColorValue = this.navbarColor;
          }
          return navbarColorValue;
        }
      }
    },
    siteNavbarType() {
      if (localStorage.getItem("userSiteInfo")) {
        if (JSON.parse(localStorage.getItem("userSiteInfo")) instanceof Array) {
          return JSON.parse(localStorage.getItem("userSiteInfo"))[0].navbarType;
        } else {
          return JSON.parse(localStorage.getItem("userSiteInfo")).navbarType;
        }
      }
    },
    sidebarWidth() {
      return this.$store.state.sidebarWidth;
    },
    bodyOverlay() {
      return this.$store.state.bodyOverlay;
    },
    contentAreaClass() {
      if (this.sidebarWidth == "default") return "content-area-default";
      else if (this.sidebarWidth == "reduced") return "content-area-reduced";
      else if (this.sidebarWidth) return "content-area-full";
    },
    navbarClasses() {
      var navbarTypeValue = this.siteNavbarType;
      if (this.navbarType) {
        navbarTypeValue = this.navbarType;
      }
      return {
        "navbar-hidden": this.navbarType == "hidden",
        "navbar-sticky": this.navbarType == "sticky",
        "navbar-static": this.navbarType == "static",
        "navbar-floating": this.navbarType == "floating"
      };
    },
    footerClasses() {
      return {
        "footer-hidden": this.footerType == "hidden",
        "footer-sticky": this.footerType == "sticky",
        "footer-static": this.footerType == "static"
      };
    }
  },
  methods: {
    changeRouteTitle(title) {
      this.routeTitle = title;
    },
    updateNavbar(val) {
      this.navbarType = val;
    },
    updateNavbarColor(val) {
      this.navbarColor = val;
      if (val == "#fff") this.isNavbarDark = false;
      else this.isNavbarDark = true;
    },
    updateFooter(val) {
      this.footerType = val;
    },
    updateRouterTransition(val) {
      this.routerTransition = val;
    },
    handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
      this.setSidebarWidth();
    },
    setSidebarWidth() {
      if (this.windowWidth < 1200) {
        this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", false);
        this.$store.dispatch("updateSidebarWidth", "no-sidebar");
      } else if (this.windowWidth < 1200) {
        this.$store.dispatch("updateSidebarWidth", "reduced");
      } else {
        this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", true);
      }
    },
    toggleHideScrollToTop(val) {
      this.hideScrollToTop = val;
    },
    updateTheme() {
      this.$setColors();
    },
  },
  created() {
    this.$store.dispatch("updateTheme", "dark");
    document.title = "DigiCampus";
    this.setSidebarWidth();
    if (this.isThemeDark) {
      this.updateNavbarColor("#10163a");
    } else {
      this.updateNavbarColor(this.navbarColor);
    }

    // this.navbarType = "hidden";

    this.$setSchoolTheme();
    this.updateTheme();
  }
};
</script>
<style lang="scss">
@import "@/digicampus/assets/main-digi.scss";
.vx-navbar-wrapper {
  background: none !important;
  padding: 2.2rem;
  padding-top: 1.3rem;
  z-index: 41000;
  height: 103px;
  position: relative;
  top: 0;
}
.vs-navbar.vx-navbar {
  background: linear-gradient(to bottom right, rgba(var(--vs-primary),1), rgba(var(--vs-secondary),1)) !important;
  padding: .8rem 1rem;
  width: calc(100% - 4.7rem);
  // width: calc(100% - 10.3rem);
  position: fixed;
  border-radius: 2.1rem;
  -webkit-transition: all .5s;
  transition: all .5s;
  z-index: 10000;
}

.router-view {
  // position: absolute !important;
  padding: 0 !important;
  padding-left: 2.2rem !important;
  top: 0 !important;
  width: calc(100% - 3.2rem);

  .router-content {
    margin-top: 0 !important;
    text-align: -webkit-center !important;
    text-align: -moz-center !important;
  }
}
</style>